import { ActionReducerMapBuilder, createAsyncThunk } from '@reduxjs/toolkit';
import { RecipeType } from '@kemu-io/kemu-types';
import { NavigateFunction } from 'react-router-dom';
import { getDefaultRecipe } from '../../../features/interface/interfaceApi';
import { setRecipeType, WorkspaceState } from '../../../features/Workspace/workspaceSlice';
import routes from '../../../common/routes/index';
import { openRecipeAction } from './openRecipeReducer';
import type { NavigateWithSearch } from '@common/hooks/useNavigateWithSearch';

/**
 * Creates a default recipe, registers it with Kemu Core
 */
export const createBrowserRecipeAction = createAsyncThunk<void, {
  name?: string,
  user: {
    id: string;
    firstName: string;
    lastName?: string;
  }
  navigate: NavigateFunction | NavigateWithSearch
}>(
  '/Workspace/createBrowserRecipe', async (options, thunkAPI) => {
    // Create a basic recipe
    const defaultRecipe = await getDefaultRecipe({
      userId: options.user.id,
      firstName: options.user.firstName,
      lastName: options.user.lastName,
    });

    if (options?.name) {
      defaultRecipe.name = options.name;
    }

    // Open it so that Kemu creates a pool id
    await thunkAPI.dispatch(openRecipeAction({
      recipe: defaultRecipe,
      isDefault: true,
      dbInfo: {
        id: '',
        authorId: options.user.id,
        version: 0,
        recipeType: RecipeType.Browser
      }
    }));

    thunkAPI.dispatch(setRecipeType({
      type: RecipeType.Browser,
      cloudInfo: null,
    }));

    // No id yet for this recipe, so we pass in an empty string to prevent showing ':id'
    options.navigate(routes.recipe.getBrowserRecipeRoute(''));
  }
);


export const createBrowserRecipeReducer = ((builder: ActionReducerMapBuilder<WorkspaceState>): void => {
  builder.addCase(createBrowserRecipeAction.fulfilled, (state) => {
    state.creatingCloudRecipe = null;
    state.baseRecipeLoaded = true;
  });

  builder.addCase(createBrowserRecipeAction.rejected, (state, action) => {
    console.log('Error creating browser recipe: ', action);
    state.creatingCloudRecipe = null;
  });

  builder.addCase(createBrowserRecipeAction.pending, (state) => {
    state.creatingCloudRecipe = null;
  });
});
